import { Images } from '@microfrontends/react-components'
import {useStore} from '../../store';
import {IconWrap} from './Benefit.css';

interface IProps {
	benefitId: number
	color?: string
}

export default function Icon({ benefitId, color }: IProps) {
	const { state } = useStore()
	const setting = {
		width: state.isMobile ? 48 : 64,
		height: state.isMobile ? 48 : 64
	}
	const renderIcon = () => {
		switch (benefitId) {
			case 1:
				return <Images.BonusIcon {...setting} color={color} />
			case 2:
				return <Images.HealthcarePlanIcon {...setting} color={color} />
			case 3:
				return <Images.PaidLeaveIcon {...setting} color={color} />
			case 4:
				return <Images.TrainingIcon {...setting} color={color} />
			case 5:
				return <Images.AwardsIcon {...setting} color={color} />
			case 6:
				return <Images.LibraryIcon {...setting} color={color} />
			case 7:
				return <Images.LaptopIcon {...setting} color={color} />
			case 8:
				return <Images.MobileIcon {...setting} color={color} />
			case 9:
				return (
					<Images.TravelOpportunitiesIcon
						{...setting}
						color={color}
					/>
				)
			case 10:
				return <Images.TeamActivitiesIcon {...setting} color={color} />
			case 11:
				return <Images.TransportationIcon {...setting} color={color} />
			case 12:
				return <Images.CanteenIcon {...setting} color={color} />
			case 13:
				return <Images.VoucherIcon {...setting} color={color} />
			case 14:
				return <Images.KindergartenIcon {...setting} color={color} />
			case 15:
				return <Images.ThreeDotIcon {...setting} color={color} />
			default:
				break
		}
	}
	return <IconWrap {...setting}>{renderIcon()}</IconWrap>
}
